import { render, staticRenderFns } from "./PhoneView.vue?vue&type=template&id=747ecc1a&"
import script from "./PhoneView.vue?vue&type=script&lang=js&"
export * from "./PhoneView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports